import styled from 'styled-components';
import { panelBackground } from '../../style/colors';
import { isset } from '../ModelView/utils';

const Panel = styled.div.attrs(
    (props) => isset(props.width) && { style: { width: props.width } }
)`
    box-shadow: 3px 3px 15px 0px rgba(0, 0, 0, 0.3);
    margin: 16px;
    padding: 16px;
    background: ${panelBackground};
    border-radius: 4px;
`;

export default Panel;

export const PanelHeader = styled.div`
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    border-bottom: 1px solid currentColor;
    padding-bottom: 4px;
    margin-bottom: 4px;
`;

const CloseButtonContainer = styled.div`
    position: relative;
    width: 16px;
    height: 16px;
    overflow: hidden;
    cursor: pointer;

    &:before,
    &:after {
        position: absolute;
        left: 50%;
        top: 0;
        content: ' ';
        height: 100%;
        width: 2px;
        background-color: currentColor;
    }
    &:before {
        transform: rotate(-45deg);
    }
    &:after {
        transform: rotate(45deg);
    }
`;

export const CloseButton = (props) => {
    return <CloseButtonContainer {...props}></CloseButtonContainer>;
};
